export default __webpack_public_path__ + "static/media/index.85c775e4.less";